module.exports = __webpack_public_path__ + "static/media/templates-dark.9fd5d1be.svg";